import styled from "styled-components";

export const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`;

export const DropdownButton = styled.button`
  width: 100%;
  font-size: ${({ theme }) => theme.typeScale.lg[200]};

  border: none;
  background-color: ${({ theme }) => theme.colors.background};
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:hover {
    border-color: #888;
  }
`;

export const Arrow = styled.span`
    margin-left:0.5rem;
    font-size: ${({ theme }) => theme.typeScale.lg[100]};
`;

export const DropdownList = styled.ul`
  position: absolute;
  top: 100%;
  left: -3.5rem;
  margin: 0;
  padding: 0;
  list-style: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.background};
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000; 
    padding:2rem;

`;

export const DropdownItem = styled.li`
  padding: 10px;
  font-size: ${({ theme }) => theme.typeScale.lg[200]};
  gap:0.5rem;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f0f0f0;
  }
`;
